// src/i18n/index.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // Utilisez Backend pour charger les traductions depuis public/locales
  .use(Backend)
  // Ajouter la détection automatique de langue (optionnel)
  .use(LanguageDetector)
  // Passer i18next à react-i18next
  .use(initReactI18next)
  .init({
    // Ne spécifiez pas de ressources ici, elles seront chargées avec Backend
    fallbackLng: 'fr',
    debug: process.env.NODE_ENV === 'development',
    
    // Configuration pour charger les fichiers depuis public/locales
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    
    interpolation: {
      escapeValue: false // React échappe déjà les valeurs
    }
  });

export default i18n;